<h2 class="text-navy" mat-dialog-title>
  <span *ngIf="data.action === '_CREATE_GROUP'">{{
    'admin-fields.create-group-label' | translate
  }}</span>
  <span *ngIf="data.action === '_EDIT_GROUP'">{{
    'admin-fields.edit-group-label' | translate : { name: data.state.label }
  }}</span>
</h2>
<button class="close-button" color="primary" mat-dialog-close mat-button aria-label="close icon">
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content class="relative">
  <div *ngIf="data.target === '_TRANSACTION'" class="mt-6 md:flex md:items-stretch">
    <div class="flex-grow">
      <div class="p-4 rounded-2xl bg-light-gray md:p-8 md:rounded-4xl">
        <div class="flex flex-col items-start justify-between md:flex-row md:items-center">
          <div *ngIf="isFetchingWallet" class="flex items-center justify-center w-full h-full">
            <app-spinner class="inline-block w-8 h-8 ml-4"></app-spinner>
          </div>
          <div *ngIf="!isFetchingWallet" class="flex items-center justify-start">
            <app-image-render img="assets/svg/wallet.svg" class="w-14"></app-image-render>
            <div
              *ngIf="wallet && currentRole.group.type !== groupeType.Admin"
              class="flex flex-col items-end justify-center font-bold text-navy"
            >
              <p class="text-lg">
                {{ _toMoney(wallet.amount) }}
                {{ currency ? currency.code : '' }}
              </p>
              <p *ngIf="wallet" class="text-[9px]">
                {{ wallet.amount }} {{ 'kimbo-home.healthcredit-label' | translate }}
              </p>
            </div>
            <div
              *ngIf="
                !isFetchingGroupCurrency &&
                groupUserCurrency &&
                currentRole.group.type === groupeType.Admin
              "
              class="flex flex-col items-end justify-center font-bold text-navy"
            >
              <p class="text-lg">
                {{ _toMoney(wallet.amount) }}
                {{ currency ? currency.code : '' }}
                <span
                  *ngIf="groupUserCurrency.code !== currency.code"
                  class="text-xs font-normal"
                  >{{ 'common.my-currency' | translate }}</span
                >
              </p>
              <p *ngIf="groupUserCurrency.code !== currency.code" class="text-lg">
                {{ _toMoney_(wallet.amount, groupUserCurrency.rate) }}
                {{ groupUserCurrency.code }}
                <span class="text-xs font-normal">{{
                  'common.my-group-currency' | translate
                }}</span>
              </p>
              <p class="text-[10px] mt-[.6rem]">
                {{ wallet.amount }} {{ 'kimbo-home.healthcredit-label' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isLoading" class="flex items-center justify-center w-full h-full py-8">
    <app-spinner class="inline-block w-8 h-8 ml-4"></app-spinner>
  </div>
  <form
    *ngIf="
      !isLoading &&
      (!_role_selected || (!isLoading && _role_selected && !_role_selected.group.is_benefit))
    "
    class=""
    [formGroup]="form"
    (ngSubmit)="save()"
  >
    <app-form-field
      class="flex justify-center w-full"
      [classNames]="'justify-center'"
      htmlFor="_PHOTO"
    >
      <div class="my-4">
        <app-avatar
          *ngIf="!imageName && !_role_selected"
          class="w-24 h-24"
          [classNames]="'w-24 h-24'"
          [withFrame]="false"
          [src]="DEFAULT_IMAGE"
        ></app-avatar>
        <app-avatar
          *ngIf="imageName"
          class="w-24 h-24"
          [classNames]="'w-24 h-24'"
          [withFrame]="false"
          [src]="imageName"
        ></app-avatar>
        <app-avatar
          *ngIf="_role_selected && !imageName"
          class="w-24 h-24"
          [classNames]="'w-24 h-24'"
          [withFrame]="false"
          [src]="getGroupImageProfil()"
        ></app-avatar>
      </div>
      <app-file-input
        *ngIf="!isLoading"
        accept=".jpg,.jpeg,.png,.gif"
        name="image"
        (changeEvent)="setFieldValue($event)"
        id="create-contact.image"
        theme="blue-outline"
        caller="_HCP"
      >
        {{ 'kimbo-profile.image-button' | translate }}
      </app-file-input>
      <ul class="mt-4">
        <li>
          <app-file-upload
            *ngIf="displayableFileName"
            [editable]="true"
            [filename]="displayableFileName"
            (triggerEvent)="handleUploadComponentChanges($event)"
          >
          </app-file-upload>
        </li>
      </ul>
    </app-form-field>

    <h5
      *ngIf="data.action === '_CREATE_GROUP' && data.caller === '_ADMIN'"
      class="mt-2 mb-4 text-base text-navy"
    >
      {{ 'kimbo-layout.choose-group-type' | translate }}
    </h5>

    <ul
      *ngIf="data.action === '_CREATE_GROUP' && data.caller === '_ADMIN'"
      class="items-center w-full mb-4 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex"
    >
      <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r">
        <div class="flex items-center pl-3">
          <input
            (click)="toggleSelection('_INDV')"
            [checked]="isIndividual"
            id="horizontal-list-radio-particular"
            type="radio"
            value=""
            name="list-radio"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2"
          />
          <label
            for="horizontal-list-radio-particular"
            class="w-full py-3 ml-2 text-sm font-medium text-gray-900"
            >{{ 'sign-in.before-login-individual' | translate }}
          </label>
        </div>
      </li>
      <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r">
        <div class="flex items-center pl-3">
          <input
            (click)="toggleSelection('_COMP')"
            [checked]="isCompany"
            id="horizontal-list-radio-enterprise"
            type="radio"
            value=""
            name="list-radio"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2"
          />
          <label
            for="horizontal-list-radio-enterprise"
            class="w-full py-3 ml-2 text-sm font-medium text-gray-900"
            >{{ 'sign-in.before-login-corporate' | translate }}</label
          >
        </div>
      </li>
      <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r">
        <div class="flex items-center pl-3">
          <input
            (click)="toggleSelection('_BENEF')"
            [checked]="isBenefit"
            id="horizontal-list-radio-benefits"
            type="radio"
            value=""
            name="list-radio"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2"
          />
          <label
            for="horizontal-list-radio-benefits"
            class="w-full py-3 ml-2 text-sm font-medium text-gray-900"
            >Benefit</label
          >
        </div>
      </li>
      <li class="w-full">
        <div class="flex items-center pl-3">
          <input
            (click)="toggleSelection('_HCP')"
            [checked]="isHcp"
            id="horizontal-list-radio-hcp"
            type="radio"
            value=""
            name="list-radio"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2"
          />
          <label
            for="horizontal-list-radio-hcp"
            class="w-full py-3 ml-2 text-sm font-medium text-gray-900"
            >{{ 'sign-in.before-login-hcp' | translate }}
          </label>
        </div>
      </li>
    </ul>
    <app-form-field
      *ngIf="data.caller !== '_ADMIN'"
      [label]="'forms.full-name-label' | translate"
      class="block w-full mt-6"
    >
      <input
        class="
         {{ input_cls.common }}
       {{ disabled ? input_cls.disabled : '' }}"
        type="text"
        [placeholder]="'forms.group-placeholder' | translate"
        formControlName="name"
        id="name"
      />
    </app-form-field>
    <app-form-field
      *ngIf="data.caller === '_ADMIN'"
      [label]="'forms.full-name-label' | translate"
      class="w-full mt-6"
    >
      <input
        class="
         {{ input_cls.common }}
       {{ disabled ? input_cls.disabled : '' }}"
        type="text"
        formControlName="name"
        [value]="data.state.label"
        id="name"
      />
    </app-form-field>

    <div
      *ngIf="data.action === '_CREATE_GROUP'"
      class="w-full flex-col sm:items-end flex justify-center {{
        form.valid && (isIndividual || isCompany || isHcp || isBenefit)
          ? 'border-t-1 border-gray'
          : ''
      }} flex-shrink-0  mt-6 h-24"
    >
      <div class="flex items-center justify-end w-full mt-6">
        <button
          class="h-12"
          mat-raised-button
          color="primary"
          [disabled]="
            !(form.valid && (isIndividual || isCompany || isHcp || isBenefit)) || isLoading
          "
          type="submit"
        >
          <app-spinner *ngIf="isLoading" class="inline-block w-6 h-6 filter-blue"></app-spinner>
          <span *ngIf="!isLoading">{{ 'forms.save-changes-button' | translate }}</span>
        </button>
      </div>
    </div>
    <div
      *ngIf="data.action === '_EDIT_GROUP' && _role_selected && !_role_selected.group.is_benefit"
      class="w-full flex-col sm:items-end flex justify-center {{
        data.caller !== '_ADMIN' ? 'border-b-1 border-gray' : ''
      }}  flex-shrink-0  my-6 h-24"
    >
      <div class="flex items-center justify-between w-full">
        <button
          *ngIf="form.valid && (isIndividual || isCompany || isBenefit)"
          class="h-12"
          mat-raised-button
          color="primary"
          [disabled]="isLoading"
          type="submit"
        >
          <app-spinner *ngIf="isLoading" class="inline-block w-6 h-6 filter-blue"></app-spinner>
          <span *ngIf="!isLoading">{{ 'forms.save-changes-button' | translate }}</span>
        </button>

        <button
          *ngIf="_role_selected && _role_selected.group.type === groupeType.Hcp"
          class="h-12"
          mat-raised-button
          color="primary"
          [disabled]="isLoading"
          type="submit"
        >
          <app-spinner *ngIf="isLoading" class="inline-block w-6 h-6 filter-blue"></app-spinner>
          <span *ngIf="!isLoading">{{ 'forms.save-changes-button' | translate }}</span>
        </button>
      </div>
    </div>
  </form>
  <div
    *ngIf="
      (data.action === '_EDIT_GROUP' && isOwer && data.caller !== '_ADMIN') ||
      data.target === '_TRANSACTION'
    "
  >
    <div
      class="p-5 mb-4 bg-gray-50 rounded-lg border border-gray-100 relative {{
        _role_selected && _role_selected.group.is_benefit ? 'mt-6' : ''
      }}"
    >
      <h5 class="text-lg font-semibold text-gray-900">
        {{ 'kimbo-layout.group-member' | translate }}
      </h5>
      <div
        *ngIf="formatedMemberList.length !== 0"
        class="flex items-center justify-end w-full mb-6 xs:absolute top-2 right-1"
      >
        <button
          class="h-12"
          mat-button
          color="primary"
          (click)="toggleCreateOverlayVisibility()"
          type="button"
          [disabled]="isLoading"
        >
          <mat-icon *ngIf="!isLoading">add</mat-icon>
          <app-spinner *ngIf="isLoading" class="inline-block w-6 h-6 filter-blue"></app-spinner>
          <span *ngIf="!isLoading">{{ 'kimbo-layout.add-group-member' | translate }}</span>
        </button>
      </div>
      <div *ngIf="isLoading" class="flex items-center justify-center w-full h-20">
        <app-spinner class="inline-block w-8 h-8 ml-4"></app-spinner>
      </div>
      <div
        *ngIf="formatedMemberList.length === 0"
        class="flex flex-col items-center justify-center gap-5 mt-8"
      >
        <span class="text-lg font-semibold text-navy">{{
          'kimbo-layout.no-member-message' | translate
        }}</span>
        <button
          class="h-12"
          mat-raised-button
          color="primary"
          [disabled]="(_role_selected && _role_selected.group.type === groupeType.Hcp) || isLoading"
          (click)="toggleCreateOverlayVisibility()"
        >
          <app-spinner *ngIf="isLoading" class="inline-block w-6 h-6 filter-blue"></app-spinner>
          <span *ngIf="!isLoading">{{ 'kimbo-layout.add-group-member' | translate }}</span>
        </button>
      </div>
      <ol
        *ngIf="formatedMemberList.length > 0 && !isGettingMember"
        class="relative mt-3 transition-all divide-y divide-white divider-gray-200"
      >
        <li class="flex justify-between items-center">
          <a class="items-center block w-full p-3 xs:flex">
            <div class="relative w-fit h-fit">
              <div
                class="absolute w-4 h-4 top-0 right-0 border-2 border-white rounded-full {{
                  formatedMemberList[0].active ? ' bg-green' : 'bg-red'
                }}"
              ></div>

              <app-avatar
                class="flex-shrink w-12 h-12 mb-3 mr-3 cursor-pointer sm:mb-0"
                classNames="w-12 h-12"
                [withFrame]="false"
                [src]="
                  formatedMemberList[0].image
                    ? (formatedMemberList[0].image! | imageToUrl)
                    : 'assets/svg/rect-gray.svg'
                "
              ></app-avatar>
            </div>
            <div class="pl-2 text-gray-600">
              <div *ngIf="formatedMemberList[0].user_id !== null" class="text-base font-normal">
                <span class="font-medium text-gray-900">{{
                  formatedMemberList[0].name === '__'
                    ? formatedMemberList[0].tel
                    : formatedMemberList[0].name
                }}</span>
              </div>
              <div
                *ngIf="formatedMemberList[0].user_id === null"
                class="mb-1 text-base font-normal"
              >
                <span class="font-medium text-gray-900">{{ formatedMemberList[0].tel }}</span>
              </div>
              <span
                *ngFor="let perm of formatedMemberList[0].permissions"
                class="inline-block  w-auto px-1 font-bold text-xxs border-1 text-center rounded-full mr-1 {{
                  perm === p_ower
                    ? 'border-solid text-green'
                    : perm === p_member
                    ? 'border-solid text-blue'
                    : ''
                }}"
              >
                {{ 'kimbo-layout.' + perm | translate }}
              </span>
              <span
                class="inline-block px-1 w-fit font-bold text-xxs border-1 text-center rounded-full mr-1 {{
                  formatedMemberList[0].active ? 'border-solid text-green' : 'border-solid text-red'
                }}"
                >{{
                  (formatedMemberList[0].active
                    ? 'kimbo-layout.member-actif-label'
                    : 'common.invitation-send'
                  ) | translate
                }}</span
              >
            </div>
          </a>
          <div
            *ngIf="formatedMemberList[0].user_id !== user.id"
            class="flex items-center justify-end gap-1"
          >
            <app-square-button
              type="button"
              size="normal"
              theme="blue"
              class="flex ml-2 mr-3 items-top"
              (click)="toggleCreateOverlayVisibility(formatedMemberList[0])"
            >
              <div
                class="w-6 h-6 stroke-current text-blue"
                aria-label="pencil icon"
                [inlineSVG]="'assets/svg/pencil.svg'"
              ></div>
            </app-square-button>
            <app-square-button
              type="button"
              size="normal"
              theme="blue"
              class="flex ml-2 mr-3 items-top"
              (click)="deleteMember(formatedMemberList[0])"
            >
              <div
                class="w-6 h-6 stroke-current text-red"
                aria-label="trash icon"
                [inlineSVG]="'assets/svg/trash.svg'"
              ></div>
            </app-square-button>
          </div>
        </li>
        <div *ngIf="allRolesIsVisible">
          <li
            *ngFor="let member of formatedMemberList; let i = index"
            class="flex justify-between items-center {{
              i !== 0 ? ' border-b-1 border-b-white' : 'hidden'
            }}"
          >
            <a class="items-center block w-full p-3 xs:flex">
              <div class="relative w-fit h-fit">
                <div
                  class="absolute w-4 h-4 top-0 right-0 border-2 border-white rounded-full {{
                    member.active ? ' bg-green' : 'bg-red'
                  }}"
                ></div>
                <app-avatar
                  class="flex-shrink w-12 h-12 mb-3 mr-3 cursor-pointer sm:mb-0"
                  classNames="w-12 h-12"
                  [withFrame]="false"
                  [src]="member.image ? (member.image | imageToUrl) : 'assets/svg/rect-gray.svg'"
                ></app-avatar>
              </div>
              <div class="pl-2 text-gray-600">
                <div *ngIf="member.user_id !== null" class="text-base font-normal">
                  <span class="font-medium text-gray-900">
                    {{
                      member.name !== '__'
                        ? member.name
                        : member.tel !== '__'
                        ? member.tel
                        : member.email
                    }}
                  </span>
                </div>
                <div *ngIf="member.user_id === null" class="text-base font-normal">
                  <span class="font-medium text-gray-900">{{ member.tel }}</span>
                </div>
                <span
                  *ngFor="let perm of member.permissions"
                  class="inline-block  w-auto px-1 font-bold text-xxs border-1 text-center rounded-full mr-1 {{
                    perm === p_ower
                      ? 'border-solid text-green'
                      : perm === p_member
                      ? 'border-solid text-blue'
                      : ''
                  }}"
                >
                  {{ 'kimbo-layout.' + perm | translate }}
                </span>
                <span
                  class="inline-block px-1 w-fit font-bold text-xxs border-1 text-center rounded-full mr-1 {{
                    member.active ? 'border-solid text-green' : 'border-solid text-red'
                  }}"
                  >{{
                    (member.active ? 'kimbo-layout.member-actif-label' : 'common.invitation-send')
                      | translate
                  }}</span
                >
              </div>
            </a>
            <div *ngIf="member.user_id !== user.id" class="flex items-center justify-end gap-1">
              <app-square-button
                type="button"
                size="normal"
                theme="blue"
                class="flex ml-2 mr-3 items-top"
                (click)="toggleCreateOverlayVisibility(member)"
              >
                <div
                  class="w-6 h-6 stroke-current text-blue"
                  aria-label="pencil icon"
                  [inlineSVG]="'assets/svg/pencil.svg'"
                ></div>
              </app-square-button>
              <app-square-button
                type="button"
                size="normal"
                theme="blue"
                class="flex ml-2 mr-3 items-top"
                (click)="deleteMember(member)"
              >
                <div
                  class="w-6 h-6 stroke-current text-red"
                  aria-label="trash icon"
                  [inlineSVG]="'assets/svg/trash.svg'"
                ></div>
              </app-square-button>
            </div>
          </li>

          <li
            *ngFor="let member of invitationsMember"
            class="flex justify-between items-center border-b-1 border-b-white"
          >
            <a class="items-center block w-full p-3 xs:flex">
              <div class="relative w-fit h-fit">
                <div
                  class="absolute w-4 h-4 top-0 right-0 border-2 border-white rounded-full bg-red"
                ></div>
                <app-avatar
                  class="flex-shrink w-12 h-12 mb-3 mr-3 cursor-pointer sm:mb-0"
                  classNames="w-12 h-12"
                  [withFrame]="false"
                  [src]="
                    member.user?.image_profil
                      ? (member.user?.image_profil | imageToUrl)
                      : 'assets/images/unknow.png'
                  "
                ></app-avatar>
              </div>
              <div class="pl-2 text-gray-600">
                <div class="text-base font-normal">
                  <span class="font-medium text-gray-900">{{ member.identifiant }}</span>
                </div>
                <span
                  class="inline-block px-1 w-fit font-bold text-xxs border-1 text-center rounded-full mr-1 border-solid text-red"
                >
                  {{ 'common.invitation-send' | translate }}
                </span>
              </div>
            </a>

            <div *ngIf="member.user_id !== user.id" class="flex items-center justify-end gap-1">
              <app-square-button
                type="button"
                size="normal"
                theme="blue"
                class="flex ml-2 mr-3 items-top"
                (click)="removeInvitation(member)"
              >
                <div
                  class="w-6 h-6 stroke-current text-red"
                  aria-label="trash icon"
                  [inlineSVG]="'assets/svg/trash.svg'"
                ></div>
              </app-square-button>
            </div>
          </li>
        </div>
      </ol>
      <div class="flex items-center justify-center w-full gap-1">
        <button
          *ngIf="formatedMemberList.length + invitationsMember.length > 1"
          class="h-12 mx-auto"
          mat-button
          color="primary"
          [disabled]="isLoading"
          (click)="toggleAllRoleVisible()"
        >
          <div class="flex items-center w-full gap-1">
            <span *ngIf="!allRolesIsVisible && !isLoading">{{
              'kimbo-layout.show-more' | translate
            }}</span>
            <span *ngIf="allRolesIsVisible && !isLoading">{{
              'kimbo-layout.show-less' | translate
            }}</span>
            <img
              appImg
              [src]="'assets/svg/' + (allRolesIsVisible ? 'chevron-up' : 'arrow-bottom') + '.svg'"
              class="w-6 h-6"
            />
          </div>
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>

<!--ADD MEMBER FORM-->

<div
  *ngIf="isCreateEditModalOpen"
  class="absolute inset-0 flex items-center justify-center rounded-lg wating-overlay z-modal-backdrop"
>
  <div class="relative w-full h-auto p-8 bg-white rounded-lg shadow-sm md:w-9/12">
    <button
      class="absolute close-button right-2 top-2"
      color="primary"
      mat-button
      (click)="closeEditRoleModal()"
    >
      <mat-icon>close</mat-icon>
    </button>
    <form class="flex flex-wrap items-start" [formGroup]="formCreateRole" (ngSubmit)="saveMember()">
      <label class="px-4 pr-0 mb-2 text-navy" htmlFor="{htmlFor}">
        {{ 'kimbo-layout.role-label' | translate }}
      </label>
      <ul
        class="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex"
      >
        <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r">
          <div class="flex items-center pl-3">
            <input
              id="vue-checkbox-list"
              type="radio"
              formControlName="permission"
              value="member"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
            />
            <label
              for="vue-checkbox-list"
              class="w-full py-3 ml-2 text-sm font-medium text-gray-900"
              >{{ 'kimbo-layout.member-label' | translate }}</label
            >
          </div>
        </li>
        <li class="w-full">
          <div class="flex items-center pl-3">
            <input
              id="laravel-checkbox-list"
              type="radio"
              formControlName="permission"
              value="owner"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
            />
            <label
              for="laravel-checkbox-list"
              class="w-full py-3 ml-2 text-sm font-medium text-gray-900"
              >{{ 'kimbo-layout.manager-label' | translate }}</label
            >
          </div>
        </li>
      </ul>
      <app-form-error *ngIf="!formCreateRole.valid" class="px-4 mt-1">
        {{ 'errors.required' | translate }}
      </app-form-error>
      <div class="relative w-full mt-6">
        <button
          *ngIf="isCreatingMember"
          style="position: absolute !important"
          class="-top-[14px] right-0 z-base"
          mat-button
          color="primary"
          (click)="toggleAggingMethod()"
          type="button"
          [disabled]="isLoading"
        >
          <app-spinner *ngIf="isLoading" class="inline-block w-6 h-6 filter-blue"></app-spinner>
          <span *ngIf="!addMemberWithPhone && !isLoading" class="inline-block p-1">{{
            'common.add-with-phone-label' | translate
          }}</span>
          <span *ngIf="addMemberWithPhone && !isLoading" class="inline-block p-1 bg-white">{{
            'common.add-with-email-label' | translate
          }}</span>
        </button>

        <app-form-field
          *ngIf="isCreatingMember && !addMemberWithPhone"
          [label]="'forms.email-label-mini' | translate"
          class="w-full mt-6 md:w-1/3-with-gap md:mt-0"
          [error]="!_isValidEmail(memberEmail) ? ('errors.invalid-email' | translate) : ''"
        >
          <input
            class="w-full
        {{ input_cls.common }}"
            type="email"
            (input)="setMemberEmail($event)"
            [placeholder]="'forms.email-placeholder' | translate"
          />
        </app-form-field>
        <app-phone-number-dropdown
          *ngIf="isCreatingMember && addMemberWithPhone"
          class="w-full mt-6"
          (triggerEvent)="handlePhoneEvent($event)"
          [options]="countryListToOptionObject()"
          [country]="country"
          [withWhatapp]="false"
          [placeholder]="'forms.phone-placeholder' | translate"
          [name]="'forms.tel-label-mini' | translate"
        ></app-phone-number-dropdown>
      </div>
      <div
        class="flex flex-col justify-center flex-shrink-0 w-full h-24 mt-6 sm:items-end border-t-1 border-gray"
      >
        <div class="flex items-center justify-end w-full mt-6">
          <button
            class="h-12 uppercase"
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="isLoading"
          >
            <app-spinner *ngIf="isLoading" class="inline-block w-6 h-6 filter-blue"></app-spinner>
            <span *ngIf="!isLoading" class="inline-block p-1">{{
              'common.send-invitation-label' | translate
            }}</span>
            <mat-icon *ngIf="!isLoading" class="ml-2">arrow_forward</mat-icon>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
